<template>
    <ob1-popin-modal2
        :id="id"
        :aria-labelledby="id + '_title'"
        :show-close-button="false"
    >
        <div :id="id + '_title'" class="h4">
            {{ title }}
        </div>
        <p class="m-0">
            {{ subtitle }}
        </p>
        <div class="row">
            <div class="col-12 col-md-6 mb-1 d-md-flex">
                <ob1-cards
                    :is-link="true"
                    :link="clientHref"
                    class="d-flex p-1 align-items-center"
                >
                    <div class="m-1">
                        <span class="icon-avatar font-size-30" />
                    </div>
                    <div>
                        <div class="lead p-0">
                            <strong>
                                {{ clientTitle }}
                            </strong>
                        </div>
                        <div class="small p-0">
                            {{ clientDescription }}
                        </div>
                    </div>
                </ob1-cards>
            </div>
            <div class="col-12 col-md-6 mb-1 d-md-flex">
                <ob1-cards
                    :is-link="true"
                    :link="newClientHref"
                    class="d-flex p-1 align-items-center"
                >
                    <div class="m-1">
                        <span class="icon-Add-person font-size-30" />
                    </div>
                    <div>
                        <div class="lead p-0">
                            <strong>
                                {{ newClientTitle }}
                            </strong>
                        </div>
                        <div class="small p-0">
                            {{ newClientDescription }}
                        </div>
                    </div>
                </ob1-cards>
            </div>
        </div>
    </ob1-popin-modal2>
</template>

<script>
export default {
    name: "AuthenticationPopin",
    props: {
        id: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: false,
            default: null
        },
        subtitle: {
            type: String,
            required: false,
            default: null
        },
        clientTitle: {
            type: String,
            required: false,
            default: null
        },
        clientDescription: {
            type: String,
            required: false,
            default: null
        },
        clientHref: {
            type: String,
            required: false,
            default: null
        },
        newClientTitle: {
            type: String,
            required: false,
            default: null
        },
        newClientDescription: {
            type: String,
            required: false,
            default: null
        },
        newClientHref: {
            type: String,
            required: false,
            default: null
        },
    }
}
</script>
